import { USER_AGENT_UPDATE } from '../actionConstants';
import defaultState, { getDeviceInfoObject } from './userAgentDefaultState';
import { UserAgent } from './userAgentTypes';
import { Action } from '../../generalTypes';

export default (
  state: UserAgent = defaultState,
  action: Action<UserAgent>
): UserAgent => {
  switch (action.type) {
    case USER_AGENT_UPDATE:
      const { deviceType, orientation } = action.payload;

      return orientation !== state.orientation ||
        deviceType !== state.deviceType
        ? {
            orientation: orientation,
            deviceType: deviceType,
            ...getDeviceInfoObject(deviceType, orientation),
          }
        : state;
    default:
      return state;
  }
};
